
import { useEffect } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { SecuritySettingsForm } from '@/components/forms/SecuritySettingsForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function SecuritySettingsPage() {
  const colors = useThemeColors()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Security Settings</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Configure two-factor authentication and session security settings
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <SecuritySettingsForm />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

